import {RestrictionRule} from '@app/core/model/filtering/restriction-rule';
import {RestrictionFilter} from '@app/core/model/filtering/restriction-filter';

export class RestrictionSet {

    constructor(public rules: RestrictionRule[]) {
    }

    getAll(currentEntity: string = null): RestrictionFilter[] {
        if (this.rules && this.rules.length > 0) {
            return currentEntity
                ? this.rules[0].items.filter((filter: RestrictionFilter) => filter.entity && filter.entity.sourceType === currentEntity)
                : this.rules[0].items;
        }
        return [];
    }

    countAllCompleted(currentEntity: string = null): number {
        /* return this.rules.filter(rule => {
            return rule.items.length > 0 && rule.isCompleted();
        }).length;*/
        return this.getAll(currentEntity).filter((filter: RestrictionFilter) => filter.isCompleted()).length;
    }

    isAllCompleted(currentEntity: string = null): boolean {
        return !this.rules || (this.rules.length === 0) || (this.countAllCompleted(currentEntity) === this.getAll(currentEntity).length);
    }

    getAppliedEntities(): string[] {
        if (this.rules && this.rules.length > 0) {
            return this.rules[0].items
                .filter((filter: RestrictionFilter) => filter.isCompleted())
                .map((filter: RestrictionFilter) => filter.entity.sourceType);
        }
        return [];
    }

    /**
     * Actually restriction group
     */
    addEmptyRule(): RestrictionRule {
        const group: RestrictionRule = new RestrictionRule();
        this.rules.push(group);
        return group;
    }

    addItemToRule(newItem: RestrictionFilter, group: RestrictionRule, force = false) {
        if (force || group.isAllCompleted()) {
            group.addItem(newItem);
        }
    }

    deleteRule(group: RestrictionRule) {
        this.rules = this.rules.filter(it => it !== group);
    }

    deleteItemFromRule(item: RestrictionFilter, group: RestrictionRule) {
        group.deleteItem(item);
    }

    resetItemFromRule(item: RestrictionFilter, group: RestrictionRule) {
        group.resetItem(item);
    }
}
